function Util(){}function resetFocusTabsStyle(){window.dispatchEvent(new CustomEvent("initFocusTabs"))}Util.hasClass=function(t,e){return t.classList.contains(e)},Util.addClass=function(t,e){e=e.split(" "),t.classList.add(e[0]),1<e.length&&Util.addClass(t,e.slice(1).join(" "))},Util.removeClass=function(t,e){e=e.split(" "),t.classList.remove(e[0]),1<e.length&&Util.removeClass(t,e.slice(1).join(" "))},Util.toggleClass=function(t,e,n){n?Util.addClass(t,e):Util.removeClass(t,e)},Util.setAttributes=function(t,e){for(var n in e)t.setAttribute(n,e[n])},Util.getChildrenByClassName=function(t,e){for(var n=t.children,o=[],i=0;i<n.length;i++)Util.hasClass(n[i],e)&&o.push(n[i]);return o},Util.is=function(t,e){if(e.nodeType)return t===e;for(var n="string"==typeof e?document.querySelectorAll(e):e,o=n.length;o--;)if(n[o]===t)return!0;return!1},Util.setHeight=function(o,i,r,s,a,l){var u=i-o,c=null;r.style.height=o+"px",window.requestAnimationFrame(function t(e){var e=e-(c=c||e),n=(s<e&&(e=s),parseInt(e/s*u+o));l&&(n=Math[l](e,o,i-o,s)),r.style.height=n+"px",e<s?window.requestAnimationFrame(t):a&&a()})},Util.scrollTo=function(o,i,r,t){var s=t||window,a=s.scrollTop||document.documentElement.scrollTop,l=null;t||(a=window.scrollY||document.documentElement.scrollTop),window.requestAnimationFrame(function t(e){var e=e-(l=l||e),n=(i<e&&(e=i),Math.easeInOutQuad(e,a,o-a,i));s.scrollTo(0,n),e<i?window.requestAnimationFrame(t):r&&r()})},Util.moveFocus=function(t){(t=t||document.getElementsByTagName("body")[0]).focus(),document.activeElement!==t&&(t.setAttribute("tabindex","-1"),t.focus())},Util.getIndexInArray=function(t,e){return Array.prototype.indexOf.call(t,e)},Util.cssSupports=function(t,e){return CSS.supports(t,e)},Util.extend=function(){var t={},e=!1,n=0,o=arguments.length;for("[object Boolean]"===Object.prototype.toString.call(arguments[0])&&(e=arguments[0],n++);n<o;n++){var i,i=void 0,r=arguments[n];for(i in r)Object.prototype.hasOwnProperty.call(r,i)&&(e&&"[object Object]"===Object.prototype.toString.call(r[i])?t[i]=extend(!0,t[i],r[i]):t[i]=r[i])}return t},Util.osHasReducedMotion=function(){var t;return!!window.matchMedia&&!!(t=window.matchMedia("(prefers-reduced-motion: reduce)"))&&t.matches},Math.easeInOutQuad=function(t,e,n,o){return(t/=o/2)<1?n/2*t*t+e:-n/2*(--t*(t-2)-1)+e},Math.easeInQuart=function(t,e,n,o){return n*(t/=o)*t*t*t+e},Math.easeOutQuart=function(t,e,n,o){return t/=o,-n*(--t*t*t*t-1)+e},Math.easeInOutQuart=function(t,e,n,o){return(t/=o/2)<1?n/2*t*t*t*t+e:-n/2*((t-=2)*t*t*t-2)+e},Math.easeOutElastic=function(t,e,n,o){var i,r=.7*o,s=n;return 0==t?e:1==(t/=o)?e+n:(r=r||.3*o,i=s<Math.abs(n)?(s=n,r/4):r/(2*Math.PI)*Math.asin(n/s),s*Math.pow(2,-10*t)*Math.sin((t*o-i)*(2*Math.PI)/r)+n+e)},function(){var o=document.getElementsByClassName("js-tab-focus"),t=!1,e=!1,n=!1;function i(){0<o.length&&(s(!1),window.addEventListener("keydown",r)),window.removeEventListener("mousedown",i),n=!(e=!1)}function r(t){9===t.keyCode&&(s(!0),window.removeEventListener("keydown",r),window.addEventListener("mousedown",i),e=!0)}function s(t){for(var e=t?"":"none",n=0;n<o.length;n++)o[n].style.setProperty("outline",e)}function a(){t?n&&s(e):(t=0<o.length,window.addEventListener("mousedown",i))}a(),window.addEventListener("initFocusTabs",a)}();


// File#: _3_drop-menu
(function() { 
  var DropMenu = function(element) {
    this.element = element;
    this.innerElement = this.element.getElementsByClassName('js-drop-menu__inner');
    this.trigger = document.querySelector('[aria-controls="'+this.element.getAttribute('id')+'"]');
    this.autocompleteInput = false;
    this.autocompleteList = false;
    this.animationDuration = parseFloat(getComputedStyle(this.element).getPropertyValue('--drop-menu-transition-duration')) || 0.3;
    // store some basic classes
    this.menuIsVisibleClass = 'drop-menu--is-visible';
    this.menuLevelClass = 'js-drop-menu__list';
    this.menuBtnInClass = 'js-drop-menu__btn--sublist-control';
    this.menuBtnOutClass = 'js-drop-menu__btn--back';
    this.levelInClass = 'drop-menu__list--in';
    this.levelOutClass = 'drop-menu__list--out';
    // store the max height of the element
    this.maxHeight = false;
    // store drop menu layout 
    this.layout = false;
    // vertical gap - desktop layout
    this.verticalGap = parseInt(getComputedStyle(this.element).getPropertyValue('--drop-menu-gap-y')) || 4;
    // store autocomplete search results
    this.searchResults = [];
    // focusable elements
    this.focusableElements = [];
    initDropMenu(this);
  };

  function initDropMenu(menu) {
    // trigger drop menu opening/closing
    toggleDropMenu(menu);
    // toggle sublevels
    menu.element.addEventListener('click', function(event){
      // check if we need to show a new sublevel
      var menuBtnIn = event.target.closest('.'+menu.menuBtnInClass);
      if(menuBtnIn) showSubLevel(menu, menuBtnIn);
      // check if we need to go back to a previous level
      var menuBtnOut = event.target.closest('.'+menu.menuBtnOutClass);
      if(menuBtnOut) hideSubLevel(menu, menuBtnOut);
    });
    // init automplete search
    // initAutocomplete(menu);
    // close drop menu on focus out
    initFocusOut(menu);
  };

  function toggleDropMenu(menu) { // toggle drop menu
    if(!menu.trigger) return;
    // actions to be performed when closing the drop menu
    menu.dropMenuClosed = function(event) {
      if(event.propertyName != 'visibility') return;
      if(getComputedStyle(menu.element).getPropertyValue('visibility') != 'hidden') return;
      menu.element.removeEventListener('transitionend', menu.dropMenuClosed);
      menu.element.removeAttribute('style');
      resetAllLevels(menu); // go back to main list
      resetAutocomplete(menu); // if autocomplte is enabled -> reset input fields
    };

    // on mobile - close drop menu when clicking on close btn
    menu.element.addEventListener('click', function(event){
      var target = event.target.closest('.js-drop-menu__close-btn');
      if(!target || !dropMenuVisible(menu)) return;
      menu.trigger.click();
    });

    // click on trigger
    menu.trigger.addEventListener('click', function(event){
      menu.element.removeEventListener('transitionend', menu.dropMenuClosed);
      var isVisible = dropMenuVisible(menu);
      menu.element.classList.toggle( menu.menuIsVisibleClass, !isVisible);
      isVisible ? menu.trigger.removeAttribute('aria-expanded') : menu.trigger.setAttribute('aria-expanded', true);
      if(isVisible) {
        menu.element.addEventListener('transitionend', menu.dropMenuClosed);
      } else {
        menu.element.addEventListener('transitionend', function cb(){
          menu.element.removeEventListener('transitionend', cb);
          focusFirstElement(menu, menu.element);
        });
        getLayoutValue(menu);
        setDropMenuMaxHeight(menu); // set max-height
        placeDropMenu(menu); // desktop only
      }
    });
  };

  function dropMenuVisible(menu) {
    return menu.element.classList.contains( menu.menuIsVisibleClass);
  };

  function showSubLevel(menu, menuBtn) {
    var mainLevel = menuBtn.closest('.'+menu.menuLevelClass),
      subLevel = getChildrenByClassName(menuBtn.parentNode, menu.menuLevelClass);
    if(!mainLevel || subLevel.length == 0 ) return;
    // trigger classes
    subLevel[0].classList.add(menu.levelInClass);
    mainLevel.classList.add(menu.levelOutClass);
    mainLevel.classList.remove(menu.levelInClass);
    // animate height of main element
    animateDropMenu(menu, mainLevel.offsetHeight, subLevel[0].offsetHeight, function(){
      focusFirstElement(menu, subLevel[0]);
    });
  };

  function hideSubLevel(menu, menuBtn) {
    var subLevel = menuBtn.closest('.'+menu.menuLevelClass),
       mainLevel = subLevel.parentNode.closest('.'+menu.menuLevelClass);
    if(!mainLevel || !subLevel) return;
    // trigger classes
    subLevel.classList.remove(menu.levelInClass);
    mainLevel.classList.add(menu.levelInClass);
    mainLevel.classList.remove(menu.levelOutClass);
    // animate height of main element
    animateDropMenu(menu, subLevel.offsetHeight, mainLevel.offsetHeight, function(){
      var menuBtnIn = getChildrenByClassName(subLevel.parentNode, menu.menuBtnInClass);
      if(menuBtnIn.length > 0) menuBtnIn[0].focus();
      // if primary level -> reset height of element + inner element
      if(mainLevel.classList.contains('js-drop-menu__list--main') && menu.layout == 'desktop') {
        menu.element.style.height = '';
        if(menu.innerElement.length > 0) menu.innerElement[0].style.height = '';
      }
    });
  };

  function animateDropMenu(menu, initHeight, finalHeight, cb) {
    if(menu.innerElement.length < 1) {
      if(cb) setTimeout(function(){cb();}, menu.animationDuration*1000);
      return;
    }
    if(menu.layout == 'mobile') {
      menu.innerElement[0].style.height = (finalHeight - 200)+"px";
      if(cb) setTimeout(function(){cb();}, menu.animationDuration*1000);
      return;
    } else {
      menu.innerElement[0].style.height = "";
    }
    var resetHeight = false;
    // make sure init and final height are smaller than max height
    if(initHeight > menu.maxHeight) initHeight = menu.maxHeight;
    if(finalHeight > menu.maxHeight) {
      resetHeight = finalHeight;
      finalHeight = menu.maxHeight;
    }
    var change = finalHeight - initHeight,
      currentTime = null,
      duration = menu.animationDuration*1000;

    var animateHeight = function(timestamp){  
      if (!currentTime) currentTime = timestamp;         
      var progress = timestamp - currentTime;
      if(progress > duration) progress = duration;
      var val = Math.easeOutQuart(progress, initHeight, change, duration);
      menu.element.style.height = val+"px";
      if(progress < duration) {
        window.requestAnimationFrame(animateHeight);
      } else {
        menu.innerElement[0].style.height = resetHeight ? (resetHeight + 250)+'px' : '';
        if(cb) cb();
      }
    };
    
    //set the height of the element before starting animation -> fix bug on Safari
    menu.element.style.height = (initHeight + 1) + "px";
    window.requestAnimationFrame(animateHeight);
  };

  function resetAllLevels(menu) {
    var openLevels = menu.element.getElementsByClassName(menu.levelInClass),
      closeLevels = menu.element.getElementsByClassName(menu.levelOutClass);
    while(openLevels[0]) {
      openLevels[0].classList.remove(menu.levelInClass);
    }
    while(closeLevels[0]) {
      closeLevels[0].classList.remove(menu.levelOutClass);
    }
  };

  function focusFirstElement(menu, level) {
    var element = getFirstFocusable(level);
    element.focus();
  };

  function getFirstFocusable(element) {
    var elements = element.querySelectorAll(focusableElString);
    for(var i = 0; i < elements.length; i++) {
			if(elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) {
				return elements[i];
			}
		}
  };

  function getFocusableElements(menu) { // all visible focusable elements
    var elements = menu.element.querySelectorAll(focusableElString);
    menu.focusableElements = [];
    for(var i = 0; i < elements.length; i++) {
			if( isVisible(menu, elements[i]) ) menu.focusableElements.push(elements[i]);
		}
  };

  function isVisible(menu, element) {
    var elementVisible = false;
    if( (element.offsetWidth || element.offsetHeight || element.getClientRects().length) && getComputedStyle(element).getPropertyValue('visibility') == 'visible') {
      elementVisible = true;
      if(menu.element.contains(element) && element.parentNode) elementVisible = isVisible(menu, element.parentNode);
    }
    return elementVisible;
  };

  // function initAutocomplete(menu) {
  //   if(!menu.element.classList.contains('js-autocomplete')) return;
  //   // get list of search results
  //   getSearchResults(menu);
  //   var autocompleteCharacters = 1;
  //   menu.autocompleteInput = menu.element.getElementsByClassName('js-autocomplete__input');
  //   menu.autocompleteList = menu.element.getElementsByClassName('js-autocomplete__results');
  //   new Autocomplete({
  //     element: menu.element,
  //     characters: autocompleteCharacters,
  //     searchData: function(query, cb) {
  //       var data = [];
  //       if(query.length >= autocompleteCharacters) {
  //         data = menu.searchResults.filter(function(item){
  //           return item['label'].toLowerCase().indexOf(query.toLowerCase()) > -1;
  //         });
  //       }
  //       cb(data);
  //     }
  //   });
  // };

  // function resetAutocomplete(menu) {
  //   if(menu.autocompleteInput && menu.autocompleteInput.length > 0) {
  //     menu.autocompleteInput[0].value = '';
  //   }
  // };

  // function getSearchResults(menu) {
  //   var anchors = menu.element.getElementsByClassName('drop-menu__link');
  //   for(var i = 0; i < anchors.length; i++) {
  //     menu.searchResults.push({label: anchors[i].textContent, url: anchors[i].getAttribute('href')});
  //   }
  // };

  function setDropMenuMaxHeight(menu) {
    if(!menu.trigger) return;
    if(menu.layout == 'mobile') {
      menu.maxHeight = '100%';
      menu.element.style.maxHeight = menu.maxHeight;
      if(menu.autocompleteList.length > 0) menu.autocompleteList[0].style.maxHeight = 'calc(100% - '+menu.autocompleteInput[0].offsetHeight+'px)';
    } else {
      menu.maxHeight = window.innerHeight - menu.trigger.getBoundingClientRect().bottom - menu.verticalGap - 15;
      menu.element.style.maxHeight = menu.maxHeight + 'px';
      if(menu.autocompleteList.length > 0) menu.autocompleteList[0].style.maxHeight = (menu.maxHeight - menu.autocompleteInput[0].offsetHeight) + 'px';
    }
  };

  function getLayoutValue(menu) {
    menu.layout = getComputedStyle(menu.element, ':before').getPropertyValue('content').replace(/\'|"/g, '');
  };

  function placeDropMenu(menu) {
    if(menu.layout == 'mobile') {
      menu.element.style.top = menu.element.style.left = menu.element.style.right = '';
    } else {
      var selectedTriggerPosition = menu.trigger.getBoundingClientRect();
			
      var left = selectedTriggerPosition.left,
        right = (window.innerWidth - selectedTriggerPosition.right),
        isRight = (window.innerWidth < selectedTriggerPosition.left + menu.element.offsetWidth);

      var rightVal = 'auto', leftVal = 'auto';
      if(isRight) {
        rightVal = right+'px';
      } else {
        leftVal = left+'px';
      }

      var topVal = (selectedTriggerPosition.bottom+menu.verticalGap)+'px';
      if( isRight && (right + menu.element.offsetWidth) > window.innerWidth) {
        rightVal = 'auto';
        leftVal = parseInt((window.innerWidth - menu.element.offsetWidth)/2)+'px';
      }
      menu.element.style.top = topVal;
      menu.element.style.left = leftVal;
      menu.element.style.right = rightVal;
    }
  };

  // function closeOnResize(menu) {
  //   getLayoutValue(menu);
  //   if(menu.layout == 'mobile' || !dropMenuVisible(menu)) return;
  //   menu.trigger.click();
  // };

  // function closeOnClick(menu, target) {
  //   if(menu.layout == 'mobile' || !dropMenuVisible(menu)) return;
  //   if(menu.element.contains(target) || menu.trigger.contains(target)) return;
  //   menu.trigger.click();
  // };

  function initFocusOut(menu) {
    menu.element.addEventListener('keydown', function(event){
      if( event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab' ) {
        getFocusableElements(menu);
        if( (menu.focusableElements[0] == document.activeElement && event.shiftKey) || (menu.focusableElements[menu.focusableElements.length - 1] == document.activeElement && !event.shiftKey)) {
          menu.trigger.click();
        }
      } else if(event.keyCode && event.keyCode == 27 || event.key && event.key.toLowerCase() == 'escape' && dropMenuVisible(menu)) {
        menu.trigger.click();
			}
    });
  };

  function getChildrenByClassName(el, className) {
    var children = el.children,
      childrenByClass = [];
    for (var i = 0; i < children.length; i++) {
      if (children[i].classList.contains(className)) childrenByClass.push(children[i]);
    }
    return childrenByClass;
  };

  Math.easeOutQuart = function (t, b, c, d) {
    t /= d;
    t--;
    return -c * (t*t*t*t - 1) + b;
  };

  // init DropMenu objects
  var dropMenus = document.getElementsByClassName('js-drop-menu');
  var focusableElString = '[href], input:not([disabled]), select:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"]), [contenteditable], summary';
  if( dropMenus.length > 0 ) {
    var dropMenusArray = [];
    for( var i = 0; i < dropMenus.length; i++) {(function(i){
      dropMenusArray.push(new DropMenu(dropMenus[i]));
    })(i);}

    // on resize -> close all drop menu elements
		// window.addEventListener('resize', function(event){
		// 	dropMenusArray.forEach(function(element){
		// 		closeOnResize(element);
		// 	});
    // });
    
    // close drop menu when clicking outside it
		// window.addEventListener('click', function(event){
    //   dropMenusArray.forEach(function(element){
		// 		closeOnClick(element, event.target);
		// 	});
		// });

  }
}());